export default (enumerable) => (
  Object.values(enumerable) as Array<keyof typeof enumerable>
);
